<div class="page-container">
  <div class="section organizations-card">
    <div class="header-row">
      <h2>{{ 'org.list.title' | translate }}</h2>
    </div>

    <div class="scrollable-content">

      <app-card>
        <app-card-content>

          <div class="form-actions">
            <div class="ml-auto header-text">
              <p class="subtitle">{{ 'org.list.subtitle' | translate }}</p>
            </div>
            <a href="/signup" class="create-org-button" data-testid="create-org-button">
              {{ 'org.list.createButton' | translate }}
            </a>
          </div>

          @if (loading()) {
          <div class="loading-state">
            <p>{{ 'org.list.loading' | translate }}</p>
          </div>
          }

          @if (error()) {
          <div class="error-state">
            <p>{{ error() }}</p>
          </div>
          }

          @if (!loading() && !error()) {
          <div class="organizations-list">
            @for (org of organizations(); track org.customer_id) {
            <div class="organization-item" [class.current]="isCurrentOrg(org.customer_id)"
              [attr.data-testid]="'org-' + org.customer_id">

              <button class="org-content" [disabled]="isCurrentOrg(org.customer_id)"
                (click)="switchOrganization(org.customer_id)">
                <div class="org-info">
                  <h3>{{ org.name }}</h3>
                  <span class="org-role">{{ org.role }}</span>
                </div>

                @if (isCurrentOrg(org.customer_id)) {
                <span class="current-badge">{{ 'org.list.currentBadge' | translate }}</span>
                } @else {
                <span class="switch-arrow">→</span>
                }
              </button>

              <app-button variant="icon" color="danger" (click)="showDeleteConfirmation(org, $event)"
                [attr.data-testid]="'delete-org-' + org.customer_id" [disabled]="isCurrentOrg(org.customer_id)"
                [attr.title]="isCurrentOrg(org.customer_id) ? ('org.list.switchTooltip' | translate) : ('org.list.deleteTooltip' | translate)">
                <app-icon name="trash-2" />
              </app-button>
            </div>
            }

            @if (organizations().length === 0) {
            <div class="empty-state">
              <p>{{ 'org.list.empty.title' | translate }}</p>
              <a href="/signup" class="create-org-link">{{ 'org.list.empty.createLink' | translate }}</a>
            </div>
            }
          </div>
          }
        </app-card-content>
      </app-card>

    </div>
  </div>

</div>
<!-- Delete Confirmation Modal -->
@if (showDeleteModal() && orgToDelete()) {
<app-modal-dialog (backdropClick)="cancelDelete()">
  <div header>
    <div class="modal-title-row">
      <div class="heading-md">{{ 'org.delete.title' | translate }}</div>
      <app-button variant="icon" (click)="cancelDelete()" data-testid="close-modal">
        <app-icon name="x" />
      </app-button>
    </div>
  </div>

  <div content>
    <div class="warning-message">
      <app-icon name="alert-triangle" />
      <p><strong>{{ 'org.delete.warning' | translate:{ name: orgToDelete()!.name } }}</strong></p>
    </div>

    <p>{{ 'org.delete.warningLabel' | translate }}</p>

    <div class="confirmation-input-group">
      <label for="confirm-org-name">{{ 'org.delete.confirmLabel' | translate }}</label>
      <input id="confirm-org-name" type="text" [(ngModel)]="deleteConfirmationInput" [placeholder]="orgToDelete()!.name"
        data-testid="delete-confirmation-input" class="confirm-input" />
    </div>
  </div>

  <div footer>
    <app-button variant="text" (click)="cancelDelete()" data-testid="cancel-delete">
      {{ 'button.cancel' | translate }}
    </app-button>
    <app-button color="danger" (click)="confirmDelete()" [disabled]="!canConfirmDelete()" data-testid="confirm-delete">
      {{ 'org.delete.button' | translate }}
    </app-button>
  </div>
</app-modal-dialog>
}